module.exports = __webpack_public_path__ + "static/img/医疗卡片3_选中状态@2x.61b574f2.png";